module.exports = __webpack_public_path__ + "img/uricordu.fb0e063b.jpg";